// Generated by robots, do not change this manually!
export var light = {
    ":root": {
        "--plasma-colors-white": "rgba(255, 255, 255, 0.96)",
        "--plasma-colors-whitePrimary": "rgba(255, 255, 255, 0.96)",
        "--plasma-colors-whiteSecondary": "rgba(255, 255, 255, 0.56)",
        "--plasma-colors-whiteTertiary": "rgba(255, 255, 255, 0.28)",
        "--plasma-colors-black": "#080808",
        "--plasma-colors-blackPrimary": "#080808",
        "--plasma-colors-blackSecondary": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-blackTertiary": "rgba(8, 8, 8, 0.28)",
        "--plasma-colors-dark01": "#171717",
        "--plasma-colors-dark02": "#232323",
        "--plasma-colors-dark03": "#363636",
        "--plasma-colors-transparent": "rgba(0, 0, 0, 0)",
        "--plasma-colors-buttonClear": "rgba(0, 0, 0, 0)",
        "--plasma-colors-buttonBlack": "#080808",
        "--plasma-colors-buttonBlackSecondary": "rgba(8, 8, 8, 0.12)",
        "--plasma-colors-buttonBlackTransparent": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-buttonWhite": "#FFFFFF",
        "--plasma-colors-buttonWhiteSecondary": "rgba(255, 255, 255, 0.12)",
        "--plasma-colors-text": "#080808",
        "--plasma-colors-link": "#2A72F8",
        "--plasma-colors-linkHover": "#4D89F9",
        "--plasma-colors-linkActive": "#0859F1",
        "--plasma-colors-linkVisited": "#2364DE",
        "--plasma-colors-linkVisitedHover": "#427AE3",
        "--plasma-colors-linkVisitedActive": "#1C54BC",
        "--plasma-colors-primary": "#080808",
        "--plasma-colors-secondary": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-tertiary": "rgba(8, 8, 8, 0.28)",
        "--plasma-colors-paragraph": "rgba(8, 8, 8, 0.8)",
        "--plasma-colors-inverse": "rgba(255, 255, 255, 0.96)",
        "--plasma-colors-background": "#FFFFFF",
        "--plasma-colors-backgroundPrimary": "#FFFFFF",
        "--plasma-colors-backgroundSecondary": "#FFFFFF",
        "--plasma-colors-backgroundTertiary": "#FFFFFF",
        "--plasma-colors-inputBorder": "rgba(0, 0, 0, 0)",
        "--plasma-colors-inputBorderHover": "rgba(0, 0, 0, 0)",
        "--plasma-colors-inputBorderFocus": "rgba(0, 0, 0, 0)",
        "--plasma-colors-inputErrorBackground": "rgba(243, 27, 48, 0.12)",
        "--plasma-colors-accent": "#296AE3",
        "--plasma-colors-success": "#0D8523",
        "--plasma-colors-warning": "#D14D00",
        "--plasma-colors-critical": "#E31227",
        "--plasma-colors-surfaceLiquid01": "rgba(8, 8, 8, 0.02)",
        "--plasma-colors-surfaceLiquid02": "rgba(8, 8, 8, 0.06)",
        "--plasma-colors-surfaceLiquid03": "rgba(8, 8, 8, 0.12)",
        "--plasma-colors-surfaceSolid01": "#FAFAFA",
        "--plasma-colors-surfaceSolid02": "#F0F0F0",
        "--plasma-colors-surfaceSolid03": "#E1E1E1",
        "--plasma-colors-surfaceCard": "#FFFFFF",
        "--plasma-colors-buttonPrimary": "#2A72F8",
        "--plasma-colors-buttonPrimaryHover": "#447ff9",
        "--plasma-colors-buttonPrimaryActive": "#2868e0",
        "--plasma-colors-buttonSecondary": "rgba(8, 8, 8, 0.06)",
        "--plasma-colors-buttonSecondaryHover": "rgba(8, 8, 8, 0.04)",
        "--plasma-colors-buttonSecondaryActive": "rgba(8, 8, 8, 0.08)",
        "--plasma-colors-buttonAccent": "#296AE3",
        "--plasma-colors-buttonSuccess": "#148F2B",
        "--plasma-colors-buttonSuccessHover": "#379740",
        "--plasma-colors-buttonSuccessActive": "#157e26",
        "--plasma-colors-buttonWarning": "#E35502",
        "--plasma-colors-buttonWarningHover": "#f76d2f",
        "--plasma-colors-buttonWarningActive": "#de550a",
        "--plasma-colors-buttonCritical": "#F31B30",
        "--plasma-colors-buttonCriticalHover": "#f53b46",
        "--plasma-colors-buttonCriticalActive": "#dc1b2b",
        "--plasma-colors-buttonChecked": "#080808",
        "--plasma-colors-buttonCheckedHover": "#080808",
        "--plasma-colors-buttonCheckedHoverColor": "hsla(0, 0%, 100%, 0.9599999785423279)",
        "--plasma-colors-buttonCheckedActive": "#080808",
        "--plasma-colors-buttonCheckedActiveColor": "hsla(0, 0%, 100%, 0.9599999785423279)",
        "--plasma-colors-buttonFocused": "#296AE3",
        "--plasma-colors-gradient": "linear-gradient(45deg, hsla(219.87577639751552, 100%, 68.43137254901961%, 1) 0%, hsla(190.1639344262295, 94.81865284974093%, 62.15686274509804%, 1) 100%)",
        "--plasma-colors-gradientDevice": "",
        "--plasma-colors-voicePhraseGradient": "",
        "--plasma-colors-skeletonGradient": "linear-gradient( 90deg, rgba(8, 8, 8, 0.09) 0%, rgba(8, 8, 8, 0.08) 6.25%, rgba(8, 8, 8, 0.05) 12.5%, rgba(8, 8, 8, 0.01) 25%, rgba(8, 8, 8, 0.05) 37.5%, rgba(8, 8, 8, 0.08) 43.75%, rgba(8, 8, 8, 0.09) 50%, rgba(8, 8, 8, 0.08) 56.25%, rgba(8, 8, 8, 0.05) 62.5%, rgba(8, 8, 8, 0.01) 75%, rgba(8, 8, 8, 0.05) 87.5%, rgba(8, 8, 8, 0.08) 93.75%, rgba(8, 8, 8, 0.09) 100% )",
        "--plasma-colors-skeletonGradientLighter": "linear-gradient( 90deg, rgba(8, 8, 8, 0.36) 0%, rgba(8, 8, 8, 0.32) 6.25%, rgba(8, 8, 8, 0.20) 12.5%, rgba(8, 8, 8, 0.04) 25%, rgba(8, 8, 8, 0.20) 37.5%, rgba(8, 8, 8, 0.32) 43.75%, rgba(8, 8, 8, 0.36) 50%, rgba(8, 8, 8, 0.08) 56.25%, rgba(8, 8, 8, 0.20) 62.5%, rgba(8, 8, 8, 0.04) 75%, rgba(8, 8, 8, 0.20) 87.5%, rgba(8, 8, 8, 0.32) 93.75%, rgba(8, 8, 8, 0.36) 100% )",
        "--plasma-colors-speechBubbleSent": "",
        "--plasma-colors-speechBubbleReceived": "",
        "--plasma-colors-overlay": "rgba(0, 0, 0, 0.8)",
        "--plasma-colors-overlaySoft": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-overlayHard": "rgba(8, 8, 8, 0.9)",
        "--plasma-colors-overlayBlur": "rgba(35, 35, 35, 0.2)",
        "--plasma-colors-darkOverlaySoft": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-darkOverlayHard": "rgba(8, 8, 8, 0.9)",
        "--plasma-colors-darkOverlayBlur": "rgba(35, 35, 35, 0.2)",
        "--plasma-colors-lightOverlaySoft": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-lightOverlayHard": "rgba(8, 8, 8, 0.9)",
        "--plasma-colors-lightOverlayBlur": "rgba(35, 35, 35, 0.2)",
        "--plasma-colors-inverseOverlaySoft": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-inverseOverlayHard": "rgba(8, 8, 8, 0.9)",
        "--plasma-colors-inverseOverlayBlur": "rgba(35, 35, 35, 0.2)",
        "--plasma-outlineSize": "0.125rem",
        "--plasma-button-l-height": "3.5rem",
        "--plasma-button-l-paddingY": "1rem",
        "--plasma-button-l-paddingX": "1.625rem",
        "--plasma-button-l-paddingContentX": "1.625rem",
        "--plasma-button-l-paddingStretchX": "1.25rem",
        "--plasma-button-l-radius": "1rem",
        "--plasma-button-l-radiusCircle": "1.75rem",
        "--plasma-button-m-height": "3rem",
        "--plasma-button-m-paddingY": "0.75rem",
        "--plasma-button-m-paddingX": "1.375rem",
        "--plasma-button-m-paddingContentX": "1.5rem",
        "--plasma-button-m-paddingStretchX": "1.25rem",
        "--plasma-button-m-radius": "0.75rem",
        "--plasma-button-m-radiusCircle": "1.5rem",
        "--plasma-button-s-height": "2.5rem",
        "--plasma-button-s-paddingY": "0.5rem",
        "--plasma-button-s-paddingX": "1.125rem",
        "--plasma-button-s-paddingContentX": "1.25rem",
        "--plasma-button-s-paddingStretchX": "1.25rem",
        "--plasma-button-s-radius": "0.75rem",
        "--plasma-button-s-radiusCircle": "1.25rem",
        "--plasma-fieldHelperText-marginTop": "0.25rem",
        "--plasma-fieldHelperText-fontFamily": "var(--plasma-typo-text-xs-font-family)",
        "--plasma-fieldHelperText-fontSize": "var(--plasma-typo-text-xs-font-size)",
        "--plasma-fieldHelperText-fontStyle": "var(--plasma-typo-text-xs-font-style)",
        "--plasma-fieldHelperText-fontWeight": "var(--plasma-typo-text-xs-bold-font-weight)",
        "--plasma-fieldHelperText-letterSpacing": "var(--plasma-typo-text-xs-letter-spacing)",
        "--plasma-fieldHelperText-lineHeight": "var(--plasma-typo-text-xs-line-height)",
        "--plasma-fieldLabel-marginBottom": "0.75rem",
        "--plasma-fieldLabel-color": "var(--plasma-colors-primary)",
        "--plasma-fieldContent-margin": "1rem",
        "--plasma-input-borderWidth": "1px",
        "--plasma-input-borderRadius": "0.75rem",
        "--plasma-input-l-height": "3rem",
        "--plasma-input-l-paddingY": "0.75rem",
        "--plasma-input-l-paddingX": "1rem",
        "--plasma-input-l-hasLabelPaddingTop": "1.4375rem",
        "--plasma-input-l-hasLabelPaddingBottom": "0.4375rem",
        "--plasma-input-l-hasContentPaddingLeft": "3.25rem",
        "--plasma-input-l-hasContentPaddingRight": "3.25rem",
        "--plasma-input-m-height": "2.5rem",
        "--plasma-input-m-paddingY": "0.5rem",
        "--plasma-input-m-paddingX": "1rem",
        "--plasma-input-m-hasContentPaddingLeft": "3.25rem",
        "--plasma-input-m-hasContentPaddingRight": "3.25rem",
        "--plasma-input-s-height": "2rem",
        "--plasma-input-s-paddingY": "0.25rem",
        "--plasma-input-s-paddingX": "1rem",
        "--plasma-input-s-hasContentPaddingLeft": "3.25rem",
        "--plasma-input-s-hasContentPaddingRight": "3.25rem",
        "--plasma-input-fontFamily": "var(--plasma-typo-body-s-font-family)",
        "--plasma-input-fontSize": "var(--plasma-typo-body-s-font-size)",
        "--plasma-input-fontStyle": "var(--plasma-typo-body-s-font-style)",
        "--plasma-input-fontWeight": "var(--plasma-typo-body-s-bold-font-weight)",
        "--plasma-input-letterSpacing": "var(--plasma-typo-body-s-letter-spacing)",
        "--plasma-input-lineHeight": "var(--plasma-typo-body-s-line-height)",
        "--plasma-input-backgroundColor": "var(--plasma-colors-surface-liquid01)",
        "--plasma-input-color": "var(--plasma-colors-primary)",
        "--plasma-input-caretColor": "var(--plasma-colors-primary)",
        "--plasma-input-placeholderColor": "var(--plasma-colors-secondary)",
        "--plasma-input-hover-backgroundColor": "var(--plasma-colors-surface-liquid02)",
        "--plasma-input-focus-backgroundColor": "var(--plasma-colors-surface-liquid02)",
        "--plasma-input-success-backgroundColor": "var(--plasma-colors-background)",
        "--plasma-input-success-color": "var(--plasma-colors-primary)",
        "--plasma-input-success-borderColor": "var(--plasma-colors-success)",
        "--plasma-input-warning-backgroundColor": "var(--plasma-colors-background)",
        "--plasma-input-warning-color": "var(--plasma-colors-primary)",
        "--plasma-input-warning-borderColor": "var(--plasma-colors-warning)",
        "--plasma-input-error-backgroundColor": "var(--plasma-colors-input-error-background)",
        "--plasma-input-error-color": "var(--plasma-colors-critical)",
        "--plasma-input-error-borderColor": "var(--plasma-colors-input-error-border)",
        "--plasma-input-focusPlaceholderColor": "var(--plasma-colors-tertiary)",
        "--plasma-inputLabel-marginTop": "0.4375rem",
        "--plasma-inputLabel-fontFamily": "var(--plasma-typo-body-xxs-font-family)",
        "--plasma-inputLabel-fontSize": "var(--plasma-typo-body-xxs-font-size)",
        "--plasma-inputLabel-fontStyle": "var(--plasma-typo-body-xxs-font-style)",
        "--plasma-inputLabel-fontWeight": "var(--plasma-typo-body-xxs-bold-font-weight)",
        "--plasma-inputLabel-letterSpacing": "var(--plasma-typo-body-xxs-letter-spacing)",
        "--plasma-inputLabel-lineHeight": "var(--plasma-typo-body-xxs-line-height)",
        "--plasma-inputLabel-color": "var(--plasma-colors-tertiary)",
        "--plasma-field-fontFamily": "var(--plasma-typo-body-s-font-family)",
        "--plasma-field-fontSize": "var(--plasma-typo-body-s-font-size)",
        "--plasma-field-fontStyle": "var(--plasma-typo-body-s-font-style)",
        "--plasma-field-fontWeight": "var(--plasma-typo-body-s-bold-font-weight)",
        "--plasma-field-letterSpacing": "var(--plasma-typo-body-s-letter-spacing)",
        "--plasma-field-lineHeight": "var(--plasma-typo-body-s-line-height)",
        "--plasma-field-color": "var(--plasma-colors-secondary)",
        "--plasma-field-success-color": "var(--plasma-colors-success)",
        "--plasma-field-warning-color": "var(--plasma-colors-warning)",
        "--plasma-field-error-color": "var(--plasma-colors-critical)",
        "color": "#080808",
        "backgroundColor": "#FFFFFF"
    }
};
//# sourceMappingURL=light.js.map